import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {}

  submitForm(event) {
    this.form.requestSubmit();
  }

  toggleElement(event) {
    const target = event.target;
    const idsAttr = target.dataset["adminToggleElementId"];
    if (!idsAttr) return;

    const shouldShow = this._shouldShow(target);
    idsAttr
      .split(",")
      .map((id) => id.trim())
      .forEach((id) => {
        const element = document.getElementById(id);
        if (!element) return;
        shouldShow ? this._show(element) : this._hide(element);
      });
  }

  _shouldShow(target) {
    const showWhen = target.dataset["adminToggleShowWhen"];
    if (showWhen !== undefined) {
      return showWhen
        .split(",")
        .map((v) => v.trim())
        .includes(target.value);
    }
    if (target.dataset["adminToggleShowWhenPresent"] === "true") {
      return target.value.trim() !== "";
    }
    return target.checked;
  }

  get form() {
    if (this.element.tagName == "FORM") {
      return this.element;
    } else {
      return this.element.parentElement.querySelector("form");
    }
  }

  _hide(element) {
    element.classList.add("no-show");
  }

  _show(element) {
    element.classList.remove("no-show");
  }
}
